<template>
    <div class="product-search">
        <el-form label-width="100px" size="small">
            <el-row>
                <el-col :lg="10" :offset="2">
                    <el-form-item label="品牌:">
                        <el-radio-group v-model="searchForm.brand_id">
                            <el-radio :label="1" >N牌</el-radio>
                            <el-radio :label="2" >S牌</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :lg="10" :offset="2">
                    <el-form-item label="類型:">
                        <el-radio-group v-model="searchForm.type" @change="changeForm">
                          <el-radio  :label="1">單品</el-radio>
                          <el-radio :label="2">組合</el-radio>
                          <el-radio :label="3">任搭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :lg="10" :offset="2">
                    <el-form-item label="單品編號:" v-if="isShowSingle">
                        <el-input v-model="searchForm.id" style="width:50%;" v-if="isShowSingle"></el-input>
                    </el-form-item>
                
                    <el-form-item label="組合編號:" v-if="isShowBundle">
                        <el-input v-model="searchForm.id" style="width:50%;" v-if="isShowBundle"></el-input>
                    </el-form-item>
             
                    <el-form-item label="任搭編號:" v-if="isShowAny">
                        <el-input v-model="searchForm.id" style="width:50%;" v-if="isShowAny"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="10" :offset="2">
                 <el-form-item label="單品名稱:" v-if="isShowSingle">
                     <el-input v-model="searchForm.name" style="width:50%;" v-if="isShowSingle"></el-input>
                 </el-form-item>
                 <el-form-item label="組合名稱:" v-if="isShowBundle">
                     <el-input v-model="searchForm.name" style="width:50%;" v-if="isShowBundle"></el-input>
                 </el-form-item>
                 <el-form-item label="任搭名稱:" v-if="isShowAny">
                     <el-input v-model="searchForm.name" style="width:50%;" v-if="isShowAny"></el-input>
                 </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :lg="10" :offset="2">
                       <el-form-item label="上架狀態:">
                        <el-radio-group v-model="searchForm.status">
                            <el-radio :label="1">上架</el-radio>
                            <el-radio :label="2">下架</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :lg="10" :offset="2">
                        <el-button type="primary" icon="el-icon-search" v-if="isShowSingle" @click="fetchProductList">單品查詢</el-button>
                        <el-button type="primary" icon="el-icon-search" v-if="isShowBundle" @click="fetchProductList">組合查詢</el-button>
                        <el-button type="primary" icon="el-icon-search" v-if="isShowAny" @click="fetchProductList">任搭查詢</el-button>
                </el-col>
            </el-row>
        
        </el-form>
        <el-row type="flex" justift="center">
            <el-col :lg="22" >
                <el-table
            :data="productList.slice((currentPage-1)*pagesize,currentPage*pagesize)"
            :header-cell-style="tableHeaderColor"
            empty-text="暫無數據"
            >
            <el-table-column
                prop="brand_id"
                label="品牌"
                align="center"
                header-align="center">
                <template slot-scope="scope">
                               {{scope.row.brand_id == 1 ? 'N牌': 'S牌'}}
                </template>
            </el-table-column>
            <el-table-column label="編號" prop="id" align="center" header-align="center"></el-table-column>
            <el-table-column label="名稱" prop="name" align="center" header-align="center"></el-table-column>
            <el-table-column label="售價" prop="price" align="center" header-align="center"></el-table-column>
            <el-table-column label="優惠" prop="on_sale" align="center" header-align="center">
                  <template slot-scope="scope">
                    {{scope.row.on_sale  ? '是': '否'}}
                    
                </template>
            </el-table-column>
            <el-table-column label="詳細" align="center" header-align="center">
                <template slot-scope="scope">
                       <el-button type="info"  icon="el-icon-more" @click="detailTabs(scope.$index, scope.row)"  circle ></el-button>
                </template>
            </el-table-column>
            <el-table-column label="狀態" align="center" header-align="center">
             <template slot-scope="scope">
                    <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949" inactive-text="下架" active-text="上架" @change="updateStatus(scope.$index, scope.row)"></el-switch>
             </template>
            </el-table-column>
        </el-table>
             <el-pagination
        background
        layout="prev, pager, next"
        :total="total1"
        @current-change="current_change"
        >
      </el-pagination>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import {mapGetters, mapActions}  from 'vuex'
    export default {
        name: 'Search',
        data() {
            return {
                searchForm: {
                    brand_id: null,
                    type: 1,
                    id: '',
                    name: '',
                    status: null
                },
                productList: [],
                      total1: 0,
                 currentPage:1,
                pagesize: 10,
                isShowSingle: true,
                isShowBundle: false,
                isShowAny: false,
                itemType: null
                 
            }
        },
        computed: mapGetters(["getProductList", "getProductError", "getProductMsg", "getBundleError", "getBundleMsg"]),
        methods: {
            ...mapActions(["fetchProductList", "productUpdateStatus", "bundleUpdateStatus"]),
            async fetchProductList(){
                
                const data = await{
                    name: this.searchForm.name,
                    id: this.searchForm.id,
                    type: this.searchForm.type,
                    status: this.searchForm.status,
                    brand_id: this.searchForm.brand_id
                }
                await this.$store.dispatch('fetchProductList', data)
                         this.productList = await this.getProductList
                         this.itemType = this.searchForm.type
                         this.total1 = this.productList.length
                         
            },
            async updateStatus(index, row){
            
                const data = await {
                    _key: row._key,
                    status: row.status
                }
                 if (this.itemType == 1) {
                       await this.$store.dispatch('productUpdateStatus', data)
                        if (this.getProductError == true) {
                     this.$notify({
                         title: '失敗',
                         message: this.getProductMsg,
                         type: 'error',
                         duration: '4500',
                         position: 'top-right'
                     });
                  }else {
                      this.$notify({
                          title: '成功',
                          message: '改變狀態成功',
                          type: 'success',
                          duration: '4500',
                          position: 'top-right'
                      });
                      
                  }
                 }else {
                       await this.$store.dispatch('bundleUpdateStatus', data)
                        if (this.getBundleError == true) {
                     this.$notify({
                         title: '失敗',
                         message: this.getBundleMsg,
                         type: 'error',
                         duration: '4500',
                         position: 'top-right'
                     });
                  }else {
                      this.$notify({
                          title: '成功',
                          message: '改變狀態成功',
                          type: 'success',
                          duration: '4500',
                          position: 'top-right'
                      });
                      
                  }
                 }
                
            },
            changeForm(){
              
                if (this.searchForm.type == 1) {
                       this.isShowSingle = true
                        this.isShowBundle = false
                        this.isShowAny = false
                      
                }else if (this.searchForm.type == 2){
                      this.isShowBundle = true
                        this.isShowSingle = false
                        this.isShowAny = false
                }else if (this.searchForm.type == 3){
                       this.isShowSingle = false
                      this.isShowBundle = false
                      this.isShowAny = true
                }
           },
             tableHeaderColor({row, column, rowIndex, columnIndex}){
                if(rowIndex === 0){
                    return `background-color: gray;color: #000;`
                }
            },
             current_change (currentPage) {
                this.currentPage = currentPage;
            },
            detailTabs(index, row){
                   const data = {key: row._key, type: this.itemType}
                this.$emit('detailTabs', data)
            }
        },
    }
</script>

<style lang="scss" >
    .product-search {
        font-size: 26px;
        font-weight: bold;
        font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
      
    }
</style>